// extracted by mini-css-extract-plugin
export var columnItem = "_da-3";
export var columnItemDraggable = "_da-4";
export var dragHandle = "_da-0";
export var dragHandleHovered = "_da-1";
export var dropdown = "_da-5";
export var dropdownContent = "_da-7";
export var dropdownInner = "_da-6";
export var filterDropdownHeader = "_da-8";
export var icon = "_da-2";
export var sectionDivider = "_da-9";